const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
};

const toTitleCase = (str) => {
    if (!str) return '';
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const truncateText = (text, maxLength = 150) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

/**
 * Formats a status value by replacing underscores with spaces and capitalizing each word
 * Reuses toTitleCase for capitalization logic
 * @param {string} status - The status value (e.g., "In_progress", "active")
 * @returns {string} Formatted status (e.g., "In Progress", "Active")
 */
const formatStatusLabel = (status) => {
    if (!status) return '';
    // Replace underscores with spaces, then use toTitleCase for capitalization
    return toTitleCase(status.replace(/_/g, ' '));
};

export {
    stringToColor,
    toTitleCase,
    truncateText,
    formatStatusLabel
}